import React, { useEffect, useMemo, useState } from "react";
import { Box, Divider, Grid } from "@mui/material";
import "./CssLayoutFrontAll.css";
import { FnAxios, RouterDOM } from "utilities/utilities";
import { ApiNavigation, ApiNavigationType } from 'enum/api';
import { IMenuItem } from "components/Layout/Menu/Layout1/MenuProps";
import { Link } from "react-router-dom";
import { IconComponents } from "components/Icon";

import ImageRecruit from "assets/images/Parallax/Icon/New Project (12).png";
import ImageHome from "assets/images/Parallax/Icon/New Project (13).png";
import ImageGallery from "assets/images/Parallax/Icon/New Project (15).png";
import ImageAboutUs from "assets/images/Parallax/Icon/New Project (16).png";
import ImageDashboard from "assets/images/Parallax/Icon/New Project (17).png";

import Tooltip from "@mui/material/Tooltip";

const MenuHomeAll = (props) => {
    const { classMenu, IsPreview, sColor, bannerRef, registerRef, dashboardRef, galleryRef, aboutusRef } = props;
    const AxiosFn = FnAxios();
    const [arrDataMenu, setarrDataMenu] = useState<IMenuItem[]>([]);
    const [nMenu, setnMenu] = useState<any>(0);

    useEffect(() => {
        getDataMenu();
    }, [window.location.pathname]);

    const getDataMenu = () => {
        //1 = FrontendTop, 2 = FrontendLeft, 3 = Backend
        let result: IMenuItem[] = [];
        AxiosFn.Get(ApiNavigation.GetMenu, { nMenuType: ApiNavigationType.FrontEndLeft }, (d) => {
            result = d.objResult.lstMenu;
            setarrDataMenu([...result]);
            setnMenu(result.length);
        })
    };

    const arrMenu = useMemo(() => {
        let arr = arrDataMenu.filter(f => f.nMenuType === 2);

        return arr;
    }, [arrDataMenu])


    const nMenuIdActive = useMemo(() => {
        let nMenuId = 6;
        switch (sColor) {
            case "#9d554b":
                nMenuId = 10;
                break;
            case "#a17560":
                nMenuId = 9;
                break;
            case "#ebb464":
                nMenuId = 8;
                break;
            case "#facc8a":
                nMenuId = 7;
                break;
        }

        return nMenuId;
    }, [sColor])

    const handleScrollTo = (nMenuId) => {
        switch (nMenuId) {
            case 6:
                if (bannerRef) {
                    const windowViewport = bannerRef.current.getBoundingClientRect();
                    window.scrollTo({
                        top: windowViewport.top + window.scrollY + 5,
                        behavior: 'smooth'
                      });
                }
                break;
            case 7:
                if (registerRef) {
                    const windowViewport = registerRef.current.getBoundingClientRect();
                    window.scrollTo({
                        top: windowViewport.top + window.scrollY + 5,
                        behavior: 'smooth'
                      });
                }
                break;
            case 8:
                if (dashboardRef) {
                    const windowViewport = dashboardRef.current.getBoundingClientRect();
                    window.scrollTo({
                        top: windowViewport.top + window.scrollY + 5,
                        behavior: 'smooth'
                      });
                }
                break;
            case 9:
                if (galleryRef) {
                    const windowViewport = galleryRef.current.getBoundingClientRect();
                    window.scrollTo({
                        top: windowViewport.top + window.scrollY + 5,
                        behavior: 'smooth'
                      });
                }
                break;
            case 10:
                if (aboutusRef) {
                    const windowViewport = aboutusRef.current.getBoundingClientRect();
                    window.scrollTo({
                        top: windowViewport.top + window.scrollY + 5,
                        behavior: 'smooth'
                      });
                }
                break;
        }

    }

    return (
        <div className={classMenu} style={{ backgroundColor: sColor }}>
            <Grid container>
                {
                    arrMenu.map((item, index) => {
                        let sKeyID = "sMenu_" + item.nMenuID;
                        let isDivider = (nMenu === (index + 1)) ? true : false;
                        let isIcon = true;
                        let sImg = "";

                        switch (item.sRoute) {
                            case "/Home":
                                isIcon = false;
                                sImg = ImageHome;
                                break;
                            case "/ApplyMember":
                                isIcon = false;
                                sImg = ImageRecruit;
                                break;
                            case "/Dashboard":
                                isIcon = false;
                                sImg = ImageDashboard;
                                break;
                            case "/GalleryListImg":
                                isIcon = false;
                                sImg = ImageGallery;
                                break;
                            case "/AboutUs":
                                isIcon = false;
                                sImg = ImageAboutUs;
                                break;
                        }

                        return (
                            <Grid item xs={12} key={sKeyID}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item xs={12} className={item.nMenuID === nMenuIdActive ? "div-MenuAction" : "div-Menu"}>
                                        <Tooltip
                                            title={item.sMenuName}
                                            placement="right"
                                            arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#fde8a8',
                                                        color: 'black',
                                                        fontSize: '14px',
                                                        borderRadius: '8px',
                                                        paddingBlock: '4%',
                                                        '& .MuiTooltip-arrow': {
                                                            color: '#fde8a8',
                                                        },
                                                    },
                                                }
                                            }}
                                        >
                                            {!IsPreview ?
                                                // <Link
                                                //     to={item.sRoute}
                                                //     preventScrollReset={true}
                                                //     style={{ textDecoration: 'none' }}
                                                //     onClick={() => {
                                                //         window.scrollTo({ top: 0, behavior: `smooth` });
                                                //     }}
                                                // >
                                                //     {isIcon === true ? IconComponents(item.sIcon) : <img src={sImg} alt={item.sMenuName} />}
                                                // </Link>
                                                <Box 
                                                    component={"button"} 
                                                    onClick={() => handleScrollTo(item.nMenuID)}
                                                    style={{
                                                        backgroundColor:'transparent',
                                                        border:'none',
                                                        height:'45px'
                                                    }}
                                                >
                                                    {isIcon === true ? IconComponents(item.sIcon) : <img src={sImg} alt={item.sMenuName} width={'100%'} height={'auto'} />}
                                                </Box>
                                                :
                                                <>
                                                    {isIcon === true ? IconComponents(item.sIcon) : <img src={sImg} alt={item.sMenuName} />}
                                                </>
                                            }
                                        </Tooltip>
                                    </Grid>
                                    {isDivider &&
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        )
                    })
                }
            </Grid>
        </div >
    );
};
export default MenuHomeAll;